import Logo from "../../assets/svgs/logo.svg";
import { AccountType } from "../../../constants/account-types.constants";
import { useUserStore } from "../../../store/user.store";
import { NavLink, useLocation } from "react-router-dom";
import Button from "../core/button.core";
import ProfileIcon from "../../assets/svgs/profile.svg";
import CollabsIcon from "../../assets/svgs/collabs.svg";

export default function Sidebar() {
  const { user, brands } = useUserStore();
  const location = useLocation();

  function HandleReturnMenu() {
    const items = [];

    items.push(
      ...[
        {
          name: "Campaigns",
          link: "/brands/campaigns/live",
          icon: CollabsIcon,
          activePattern: "/brands/campaigns",
        },
        {
          name: "Profile",
          link: "/brands/account/profile",
          icon: ProfileIcon,
          activePattern: "/brands/account/profile",
        },
      ]
    );
    return items;
  }

  const isMenuActive = (activePattern: string) => {
    return location.pathname.includes(activePattern);
  };

  return (
    <div className="z-20 flex flex-col justify-between bg-white border-black border-r w-full h-full">
      <div className="flex flex-col w-full">
        <div className="px-6 pt-8">
          <Logo />
        </div>
        <div className="flex flex-col gap-4 px-2 pt-12 w-full">
          {HandleReturnMenu()?.map((menu, idx) => {
            const isActive = isMenuActive(menu.activePattern);
            return (
              <NavLink
                // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                key={idx}
                to={menu.link}
                className={`flex items-center gap-2 font-semibold ${
                  isActive ? "text-black" : "text-secondary"
                }`}
              >
                <div className="w-full">
                  <Button
                    variant={isActive ? "secondary" : "outline"}
                    className={`flex items-center pl-5 pr-0 py-3 w-full text-sm ${
                      isActive ? "text-black" : "text-secondary border-0"
                    }`}
                  >
                    <div className="flex items-center gap-2 w-full">
                      <menu.icon /> <p className="mt-1">{menu.name}</p>
                    </div>
                  </Button>
                </div>
              </NavLink>
            );
          })}
        </div>
      </div>

      <div className="flex flex-col w-full">
        <div className="flex items-center gap-2 pt-5 pb-10 pl-4 border-t w-full">
          <img
            width={50}
            height={50}
            src={brands?.[0]?.logo?.url || "/static/profile.png"}
            className="rounded-full w-12 h-12 object-cover"
            alt=""
          />
          <div className="flex flex-col">
            <p className="font-semibold text-secondary text-xs">Logged in as</p>
            {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
            <p className="flex font-figtree font-semibold text-black text-lg">
              {user?.accountType === AccountType.EPHEMERAL && user?.name}
              {user?.accountType === AccountType.ADMIN && user?.name}
              {user?.accountType === AccountType.BRAND && user?.name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
